<template>
	<div :style="wrapStyleObj">
		<label
			class="NS-label">
            <span class="NS-label__group">
                 <span class="NS-label-title"
					   v-html="$t(settings.translation.title)">
                 </span>
                <slot></slot>
            </span>

			<span
				class="NS-label__input--wrap"
				:class="[settings.condition.additionalClass, {
              error: settings.condition.error,
              successfully: settings.condition.success,
              disabled: settings.condition.disabled || settings.condition.readonly,
              filling: isFilling && !settings.condition.error,
              overflowShadow: isOverflow
              }]"
			>
            <input
				class="NS-label__input" :type="settings.type || 'text'"
				:placeholder="$t(settings.translation.placeholder)"
				@change="onChange($event)"
				:tabindex="settings.condition.tabindex"
				:value="value"
				:autocomplete="settings.condition.autocomplete"
				@input="updateSelf($event.target.value)"
				ref="input"
				:name="settings.name"
				:disabled="settings.condition.disabled"
				:readonly="settings.condition.readonly"
				@blur="$emit('blur', $event)"
			>
            <i
				v-show="settings.condition.iconClass"
				class="fa NS-label__input--envelop"
				:class="settings.condition.iconClass">
            </i>
            <i
				class="fa fa-exclamation-circle NS-label__input--error"
				v-show="settings.condition.error"
				:class="{'tip tip-hover-sm': settings.errorTip}"
			>
                <span class="tip-item">
                    <span class="tip-item-wrap">
                        {{ $t(settings.tipText) }}
                    </span>
                </span>
            </i>
            <i
				class="fa fa-check NS-label__input--successfully"
				v-show="settings.condition.success || settings.condition.successIcon"></i>
            <transition name="slide-fade">
                  <span
					  class="NS-label__input--errormessage"
					  v-show="settings.condition.error"
					  v-html="$t(settings.translation.errorText)"
				  ></span>
            </transition>

            </span>
		</label>
	</div>
</template>

<script>


	import { defaultInput } from "@/plugin/inputMixins";

	export default {

		data: function () {
			return {}
		},
		computed: {
			wrapStyleObj() {
				if (this.settings.condition.order && this.settings.condition.order.isOrder)
					return {
						order: this.settings.condition.order.number
					}
			},
			isRequired: {
				get() {
					return this.settings.condition.isRequired
				},
				set(val) {
					this.settings.condition.isRequired = val;
				}
			}
		},
		methods: {
			updateSelf(val) {
				if (this.settings.condition.isRequired)
					val.length > 0 ?
						this.settings.condition.error = false :
						this.settings.condition.error = true;

				this.$emit('input', val);
			},
			onChange(ev) {
				this.checkFilling(ev.target.value);
				this.$emit('change', ev);
			}
		},
		watch: {
			isRequired() {
				this.settings.condition.error = false;
			},
			value(val) {
				if (this.checkFillingCount) {
					this.checkFilling(val);
					this.checkFillingCount = false;
				}

				this.checkOverflow(val);
			}
		},
		mounted() {
			this.checkFilling(this.value);
			this.checkOverflow(this.value);
			if (this.settings.condition.autofocus)
				this.$refs.input.focus();
		},
		props: ['settings', 'value'],
		mixins: [defaultInput]
	}

</script>